const persistenceConfiguration = [
  'twitch.token',
  'twitch.channel',
  'twitch.video',
  'twitch.showChat',
  'twitch.refreshInterval',
];

export default persistenceConfiguration;
